import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '../theme/default.styl';

Vue.use(Vuetify, {
  customProperties: true
});
